export default "__VITE_ASSET__baee727d__"